import React, { CSSProperties, useMemo, useRef } from 'react';
import { SelectionType } from '../../enums/SelectionType.enum';
import styles from './QuickViewMobile.module.scss';
import { useProductAssets } from '../../hooks/useProductAssets';
import { ProductControls } from '../../components/ProductControls';
import { ProductPerks } from '../../components/ProductPerks';
import { ProductPriceSummary } from '../../components/ProductPriceSummary';
import { sizeImage } from '../../util';
import { ImageLoader } from './ImageLoader';
import { Icon } from '../../icons/Icon';
import { useSetModalState } from '../../hooks/actions/useModalState';
import { ModalToggleState } from '../../models/actionStates';
import { DivButton } from '../../root/components/DivButton';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';
import { useProductSelection } from '../../hooks/useProductSelection';
import { Link } from '../../root/components/Link';

const imageStyle: CSSProperties = {
  maxWidth: '100vw',
  width: '100%',
};

interface Props {
  selectionKey: string;
}

export const QuickViewMobile: React.FC<Props> = ({ selectionKey }) => {
  const { product, color, variant } = useProductSelection(SelectionType.QuickView, selectionKey);
  const reviewsRef = useRef<HTMLDivElement>(null);
  const productAssets = useProductAssets(product);
  const setModalState = useSetModalState();

  const modelPhotos = useMemo(() => {
    return productAssets.modelPhotos.filter((p) => p.color === color);
  }, [color, productAssets]);

  return (
    <div className={styles.hlQuickView} id="hl-quick-view">
      <CardHeader inlineStyles={{ marginTop: '4vh' }}></CardHeader>
      <CardBody style={{ paddingBottom: 120 }}>
        <DivButton onClick={() => setModalState({ toggleState: ModalToggleState.Closed })} className={styles.closeBtn} label="Close modal">
          <Icon name="close" style={{ width: '12px', marginLeft: '8px' }} />
        </DivButton>
        <ProductPriceSummary product={product} variant={variant} reviewsSectionRef={reviewsRef} color={color} style={{ margin: '30px 20px 0 20px' }} />
        <ProductPerks product={product} style={{ margin: '10px 20px' }} />
        <ImageLoader style={imageStyle} alt={`${product.title}`} src={sizeImage(modelPhotos[0]?.src, '800x')} />
        <ProductControls selectionType={SelectionType.QuickView} selectionKey={selectionKey} />
        <Link
          buttonType="secondary"
          size={'medium'}
          dataTrackLabel="Quick View Details"
          dataTrackLocation="Quick View Details"
          href={`/products/${product.handle}`}
          text="View More Details"
        />
      </CardBody>
    </div>
  );
};

export default QuickViewMobile;
